import styled from "styled-components";

export const TableRow = styled.tr`
    font-size: inherit;
    &:nth-child(even) td,
    &:nth-child(even) th {
        background: #0001;
    }
    &:nth-child(odd) td,
    &:nth-child(odd) th {
        background: #0000;
    }
`;

export const TableHoverRow = styled(TableRow)`
    cursor: pointer;
    &:hover {
        background: #0022;
    }
`;

export const TableHead = styled.thead``;
export const TableBody = styled.tbody``;
export const TableFoot = styled.tfoot``;

export const TableHeader = styled.th`
    padding: 0.25em;
    text-align: left;
    font-size: inherit;
    white-space: nowrap;
    position: relative;
`;

export const TableHeaderTop = styled.th`
    padding: 0.25em;
    text-align: left;
    font-size: inherit;
    border-bottom: 3px solid #eee;
    border-left: 3px solid #eee;
`;

export const TableData = styled.td`
    padding: 0.25em;
    font-size: inherit;
    white-space: nowrap;
    position: relative;
    /* border: 1px solid #0002; */
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: inherit;
`;

export const TableContainer = styled.div`
    overflow: auto;
`;
